import { render, staticRenderFns } from "./ShopSettings.vue?vue&type=template&id=0dedc24b&"
import script from "./ShopSettings.vue?vue&type=script&lang=js&"
export * from "./ShopSettings.vue?vue&type=script&lang=js&"
import style0 from "./ShopSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports